<template>
  <el-dialog
    title="学员选择"
    :visible.sync="studentDialog.show"
    v-if="studentDialog.show"
    :close-on-click-modal="false"
    @before-close="cancel"
    width="1000px"
  >
    <div class="main-contant">
      <div class="left-tree">
        <DeptTree :defaultId="defaultId" @select="select" @clearCheckedNodes="clearCheckedNodes" showTooltip/>
      </div>
      <div class="right-table">
        <div class="top-filter">
          <el-input
            v-model="name"
            placeholder="请输入名字"
            size="small"
            class="name-input"
          ></el-input>
          <butn btntype="primary" @click="queryClick()" title="查询"></butn>
          <butn btntype="primary" @click="resetClick()" title="重置"></butn>
        </div>
        <el-table
          ref="pageListTable"
          :data="tableData"
          border
          :row-style="{ color: '#51627D', fontWeight: 400 }"
          :header-row-style="{ color: '#343C4A', fontWeight: 500 }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="userName" label="姓名"> </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="sizeChange"
          @current-change="pageChange"
          :current-page="currentPage"
          :page-size="size"
          :page-sizes="[10, 50, 100, 500, 1000]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
          hide-on-single-page
        />
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <butn btntype="primary" @click.native="submit()" title="确定"></butn>
      <butn btntype="primary" @click.native="cancel()" title="取消"></butn>
    </div>
  </el-dialog>
</template>

<script>
import DeptTree from "@/components/tree/leftLazyTree.vue";
import { saveStudent, getStudentList } from "@/api/enrollment";
import butn from "@/components/button/index";
import { investigationUserSave } from "@/api/investigation";
import { pageByDepts } from "@/api/user";

export default {
  name: "selectStudents",
  components: {
    DeptTree,
    butn,
  },
  props: {
    studentDialog: {
      type: Object,
      default: () => {
        return {
          show: false
        };
      },
    },
    deptTreeData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    examId: {
      type: String,
      default: () => "",
    },
    defaultId: {
      type: String,
      default: () => "",
    }
  },
  data() {
    return {
      tableData: [],
      name: "",
      deptId: "",
      total: 0,
      currentPage: 1,
      size: 10,
      userIdList: new Set(),
      nowPageIds: [],
      hasIds: [],
      deptLevelCodes: null,
    };
  },
  mounted() {
    // this.select({deptId: this.defaultId})
  },
  methods: {
    resetClick() {
      this.name = "";
      this.queryClick();
    },
    queryClick() {
      if (this.deptLevelCodes) {
        this.currentPage = 1;
        this.getList();
      } else {
        this.$message.warning("请先选择部门或学院！");
      }
    },
    submit() {      
      if (this.userIdList.size === 0) {
        this.$message({
          message: "请选择调查人员",
          type: "warning"
        });
      } else {
        investigationUserSave({
          investigationId: this.examId,
          userIdList: Array.from(this.userIdList)
        }).then(res => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "新增成功",
            type: "success"
          });
          this.$emit("closeSelect", true);
        });
      }
    },
    cancel() {
      this.$emit("closeSelect");
    },
    handleSelectionChange(val) {
      let temp = val.map((x) => {
        return x.uuid;
      });
      let needDels = [];
      for (let i = 0; i < this.nowPageIds.length; i++) {
        if (!temp.includes(this.nowPageIds[i])) {
          needDels.push(this.nowPageIds[i]);
        }
      }
      temp.forEach((d) => {
        this.userIdList.add(d);
      });
      needDels.forEach((d) => {
        this.userIdList.delete(d);
      });
    },
    select(obj) {
      this.currentPage = 1;
      // this.deptId = obj.deptId;
      this.deptLevelCodes = obj.deptLevelCodes;
      this.getList();
    },
    clearCheckedNodes() {
      this.deptLevelCodes = null;
    },
    pageChange(page) {
      this.currentPage = page;
      this.getList();
    },
    sizeChange(size) {
      this.size = size;
      this.getList();
    },
    getList() {
      pageByDepts({
        deptLevelCodes: this.deptLevelCodes,
        page: this.currentPage,
        name: this.name,
        limit: this.size
      }).then(({ code, data }) => {
        if (code !== 0) return;
        let { records, total } = data;
        this.tableData = records;
        this.total = total;
        this.nowPageIds = this.tableData.map((x) => x.uuid);
        let rows = [];
        this.nowPageIds.forEach((x, i) => {
          if (Array.from(this.userIdList).includes(x)) {
            rows.push(this.tableData[i]);
          }
        });
        setTimeout(() => {
          rows.forEach((row) => {
            this.$refs.pageListTable.toggleRowSelection(row, true);
          });
        }, 200);
      });
    },
    closeFrom() {},
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding: 20px;
  max-height: 1200px;
}
.main-contant {
  display: flex;
  min-height: 500px;
}
.left-tree {
  width: 350px;
  margin-right: 10px;
  max-height: 450px;
}
.right-table {
  // flex: 1;
  width: 750px;
  max-height: 450px;
}
.top-filter {
  margin-bottom: 10px;
}
.pagination {
  float: right;
}
.name-input {
  width: 250px;
  margin-right: 10px;
}
</style>